const reducer = (state, action) => {
  const { type, payload } = action;
  if (type === 'SEARCH_TEXT_CHANGE') {
    return { ...state, searchText: payload.target.value };
  }
  if (type === 'SEARCH_VALUE') {
    //Handle search functionality
    payload.preventDefault();
    return { ...state };
  }

  return state;
};

export default reducer;
